import React from 'react';

import { IUserCardParams } from './UserCard';
import { RoundedSkeleton, Skeleton } from '../Skeleton';
import s from './UserCard.css';

type TUserCardSkeleton = Pick<IUserCardParams, 'avatarSize'> & { children?: React.ReactNode };

/**
 * Скелетон карточки пользователя
 */
export const UserCardSkeleton = ({ avatarSize = 'M', children }: TUserCardSkeleton) => {
  const avatarSizes = {
    XL: 64,
    L: 48,
    M: 40,
    S: 30,
  };

  const avatarSizeAsNumber = typeof avatarSize === 'number' ? avatarSize : avatarSizes[avatarSize];

  return (
    <div className={s['wrapper']}>
      <div className={s['image']}>
        <RoundedSkeleton size={avatarSizeAsNumber} />
      </div>

      <div className={s['content']}>{children || <Skeleton width={100} />}</div>
    </div>
  );
};
